import { RetryButton } from '~publish/legacy/ai/components/AIAssistant/components/RetryButton'
import { selectContentGenerationStatus } from '~publish/legacy/ai/state/slice'
import { useAppSelector } from '~publish/legacy/store'

import styles from './Error.module.css'

import type { JSX } from 'react'

/**
 *
 */
function Error(): JSX.Element {
  const { contentGenerationError: errorMessage } = useAppSelector((state) =>
    selectContentGenerationStatus(state),
  )
  return (
    <div className={styles.wrapper}>
      <p className={styles.title}>Well this is embarrassing...</p>
      <p className={styles.message}>{errorMessage}</p>
      <RetryButton withBorder>Try Again</RetryButton>
    </div>
  )
}

export { Error }
